import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { handleToastError, parseHtml } from 'helpers/index';
import { useUnit } from 'hooks/units/index';
import useI18n from 'hooks/use-i18n';
import { QUESTION_TYPE, UNIT_STATUS } from 'constants/constants';
import { getSelectedCentre } from 'store/master';
import ButtonCompleted from '../ButtonCompleted';
import QuestionType from '../../../QuestionType/QuestionType';
import ButtonAnswer from './ButtonAnswer';

import { completeUnitAsync } from 'store/units/index';
import { showToastError } from '@core/components/toastify/ToastTypes';

const QuestionComplete = () => {
  const unitSelected = useUnit();
  const i18n = useI18n();
  const dispatch = useDispatch();
  const { query } = useRouter();
  const [list, setList] = useState([]);
  const selectedCentre = useSelector(getSelectedCentre);
  const [isLoading, setIsLoading] = useState(false);

  const isCompleted = unitSelected?.status === UNIT_STATUS.COMPLETED;
  const type = unitSelected?.complete?.question?.type;

  async function onSubmit(data) {
    const body = {
      data,
      id: unitSelected.complete.data._id,
    };

    if (unitSelected?.complete?.question?.questionLink) {
      body.id = unitSelected?.complete?.question?._id;
    }
    let param = {};
    if (selectedCentre?._id) {
      param.centreId = selectedCentre?._id;
    }
    if (
      selectedCentre?.reviewContent ||
      selectedCentre?.reviewContent === undefined
    ) {
      param.reviewContent = true;
    }
    await dispatch(
      completeUnitAsync(body, unitSelected._id, query?.slug, param),
    );
    setIsLoading(false);
  }

  async function submitFreetext() {
    const data = document.getElementById('freeText').value;

    if (!data) {
      throw 'EMPTY_ANSWER';
    }

    await onSubmit(data);
  }

  async function submitMTC() {
    const answers = unitSelected?.complete?.question?.answers;
    const data = answers?.map((answer, index) => {
      return document.getElementById(`MTP-${index}`)?.checked;
    });

    if (data?.findIndex((answer) => answer) === -1) {
      throw 'EMPTY_ANSWER';
    }

    await onSubmit(data);
  }

  async function submitFillTheGap() {
    const data = [...document.getElementsByTagName('select')]?.map(
      (answer) => answer?.options[answer.selectedIndex].text,
    );

    if (data.includes('-')) {
      throw 'EMPTY_ANSWER';
    }

    await onSubmit(data);
  }

  async function submitFillTheBlank() {
    const data = [...document.getElementsByName('blank')]?.map((item) =>
      item.value.toLowerCase(),
    );
    if (data?.length && data[0] == '') {
      throw 'EMPTY_ANSWER';
    }
    await onSubmit(data);
  }

  async function submitOrderingAnDnD() {
    const order = list?.map((answer) => answer.content);
    await onSubmit(order);
  }

  async function handleSubmit() {
    setIsLoading(true);
    try {
      switch (type) {
        case QUESTION_TYPE.MTC:
          return await submitMTC();
        case QUESTION_TYPE.FILLTHEGAP:
          return await submitFillTheGap();
        case QUESTION_TYPE.FILLINTHEBLANK:
          return await submitFillTheBlank();
        case QUESTION_TYPE.ORDERING:
        case QUESTION_TYPE.DRAGDROP:
          return await submitOrderingAnDnD();
        case QUESTION_TYPE.FREETEXT:
          return await submitFreetext();
        default:
          return null;
      }
    } catch (e) {
      setIsLoading(false);
      if (e === 'EMPTY_ANSWER') {
        showToastError('Please provide a non-empty answer');
      } else {
        handleToastError(e, i18n);
      }
    }
  }

  if (isCompleted) {
    return (
      <div className="text-center">
        <ButtonCompleted />
      </div>
    );
  }

  return (
    <div>
      <Card style={{ zIndex: 1 }}>
        <CardBody>
          {unitSelected?.complete?.question?.content &&
            parseHtml(unitSelected?.complete?.question?.content)}
          <QuestionType
            list={list}
            type={type}
            setList={setList}
            componentFooter={
              <ButtonAnswer isLoading={isLoading} onSubmit={handleSubmit} />
            }
          />
        </CardBody>
      </Card>
    </div>
  );
};

export default QuestionComplete;
